import { useMutation, MutationHookOptions, useQuery } from '@apollo/client'
import {
  COMPANY_DETAILS,
  COMPANY_DETAILS_TEST_SESSIONS_PAGINATION,
  INVITE_COMPANY_MEMBER,
  REMOVE_COMPANY_MEMBER,
} from './operations'
import {
  CompanyDetails as CompanyDetailsType,
  CompanyDetailsVariables,
  CompanyDetailsTestSessionsPagination,
  CompanyDetailsTestSessionsPaginationVariables,
  InviteCompanyMember,
  InviteCompanyMemberVariables,
  RemoveCompanyMember,
  RemoveCompanyMemberVariables,
} from '../../types'

interface FilterCompanyDetailsProps {
  companyId: string
  skipGroups?: boolean
}

interface CompanyDetailsProps {
  filter: FilterCompanyDetailsProps
  onCompleted?: (data: CompanyDetailsType) => void
}

export const useCompanyDetails = ({
  filter: { companyId, skipGroups },
  onCompleted,
}: CompanyDetailsProps) =>
  useQuery<CompanyDetailsType, CompanyDetailsVariables>(COMPANY_DETAILS, {
    variables: { id: companyId, skipGroups: !!skipGroups },
    onCompleted,
  })

export const useCompanyDetailsTestSessionPagination = ({ companyId }: { companyId: string }) =>
  useQuery<CompanyDetailsTestSessionsPagination, CompanyDetailsTestSessionsPaginationVariables>(
    COMPANY_DETAILS_TEST_SESSIONS_PAGINATION,
    {
      variables: {
        filterData: { company: { id: companyId } },
      },
    }
  )

interface InviteCompanyMemberProps {
  options?: MutationHookOptions<InviteCompanyMember, InviteCompanyMemberVariables>
}

export const useInviteCompanyMember = ({ options }: InviteCompanyMemberProps = {}) =>
  useMutation<InviteCompanyMember, InviteCompanyMemberVariables>(INVITE_COMPANY_MEMBER, options)

type RemoveProps = {
  options?: MutationHookOptions<RemoveCompanyMember, RemoveCompanyMemberVariables>
}

export const useRemoveCompanyMember = ({ options }: RemoveProps = {}) => {
  const [removeCompanyMember, { loading: isRemoveCompanyMemberLoading }] = useMutation<
    RemoveCompanyMember,
    RemoveCompanyMemberVariables
  >(REMOVE_COMPANY_MEMBER, options)

  return {
    removeCompanyMember,
    isRemoveCompanyMemberLoading,
  }
}
